import React from 'react';
import './blog-post.css';
import bouquet1 from './pictures/bouquet1.jpg';
import bouquet2 from './pictures/bouquet2.jpg';
import bouquet3 from './pictures/bouquet3.jpg';
import bouquet4 from './pictures/bouquet4.jpg';
import bouquet5 from './pictures/bouquet5.jpg';
import bouquet6 from './pictures/bouquet6.jpg';


//import reportWebVitals from './reportWebVitals';

const FLWR23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Spring Member Meeting Bouquet Making Recap</h2>
                    <p class="site-post-meta">April 25, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On April 19th, we held our first Member Meeting of Spring quarter which was a flower bouquet making event. 
                        WiC members got to celebrate spring by making beautiful flower arrangements while meeting other members. 
                        It was so much fun and everyone’s flowers looked beautiful. Thank you so much to everyone who attended - 
                        we hope you had a great time! We hope to see you at future events. 
                    </p>
                    <img src={bouquet1} alt="Women in Computing members with bouquets"/>
                    <img src={bouquet2} alt="Roses"/>
                    <img src={bouquet3} alt="Women in Computing members making bouquets"/>
                    <img src={bouquet4} alt="Women in Computing members holding bouquet"/>
                    <img src={bouquet5} alt="Flower Bouquet"/>
                    <img src={bouquet6} alt="Women in Computing members making bouquets"/>        
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default FLWR23;